import React from 'react';
import { Box, Chip, Typography, Stack, Divider } from '@mui/material';
import { StopItemWithDetails } from './StopItemWithDetails';
import { groupTripsByShapeId, getFrequenciesByTripId } from '../../utils/stopUtil';
import { expandFrequencyTimes } from '../../utils/frequencyUtil';

export function RouteInfoPanel({ route, stopsByShape, stop: selectedStop, trips, frequencies }) {


    const tripsByShape = groupTripsByShapeId(trips); // `trips` should be grouped by serviceType

    return (
        <Box sx={{ p: 2, width: '100%' }}>
            {/* Route Chip */}
            <Chip
                label={route.route_short_name}
                variant="outlined"
                sx={{
                    borderColor: "orange",
                    color: "black",
                    fontWeight: 'bold',
                    mb: 1,
                    borderRadius: 1,
                }}
            />

            {/* Long Name */}
            <Typography variant="subtitle1" gutterBottom fontWeight="bold">
                {route.route_long_name}
            </Typography>

            <Divider sx={{ my: 2 }} />

            {/* Shape Sections */}
            {Object.entries(stopsByShape).map(([shapeId, stops]) => {
                const selectedTrips = tripsByShape[shapeId] || [];

                return (
                    <Box key={shapeId} sx={{ mb: 4 }}>
                        <Typography variant="body1" sx={{ mb: 1, fontWeight: 'bold' }}>
                            {selectedTrips.length > 0 ? selectedTrips[0].trip_headsign : shapeId}
                        </Typography>

                        <Stack spacing={2} sx={{ ml: 2, position: 'relative' }}>
                            {/* Vertical Line */}
                            <Box
                                sx={{
                                    position: 'absolute',
                                    top: 12,
                                    left: 7,
                                    bottom: 0,
                                    width: 2,
                                    backgroundColor: 'orange',
                                    zIndex: 0,
                                }}
                            />

                            {stops.map((stop) => {
                                const isSelected = selectedStop?.stop_id === stop.stop_id;
                                let stopFrequencies = []
                                if (stop.trip) {
                                    const frequenciesByTripId = getFrequenciesByTripId(frequencies, stop.trip.trip_id)
                                    stopFrequencies = expandFrequencyTimes(frequenciesByTripId[0]);
                                }
                                return (
                                    <StopItemWithDetails
                                        key={stop.stop_id}
                                        stop={stop}
                                        isSelected={isSelected}
                                        frequencies={stopFrequencies}
                                    />
                                );
                            })}
                        </Stack>
                    </Box>
                );
            })}

        </Box>
    );
}
